// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { InternalNetworkAgentStatusSchema } from '../inputTypeSchemas/InternalNetworkAgentStatusSchema'

/////////////////////////////////////////
// TAILSCALE NETWORK SCHEMA
/////////////////////////////////////////

export const TailscaleNetworkSchema = z.object({
  connectorStatus: InternalNetworkAgentStatusSchema,
  id: z.string(),
  tenantId: z.string(),
  slug: z.string(),
  displayName: z.string(),
  siteId: z.number().int(),
  isDefault: z.boolean(),
  isActive: z.boolean(),
  hasOverlappingCidrs: z.boolean(),
  headscaleUserId: z.string().nullable(),
  aclTag: z.string().nullable(),
  advertisedRoutes: z.string().array(),
  advertised4via6Routes: z.string().array(),
  approvedRoutes: z.string().array(),
  preAuthKeyId: z.string().nullable(),
  headscaleNodeId: z.string().nullable(),
  accessKeyId: z.string().nullable(),
  lastSeenAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type TailscaleNetwork = z.infer<typeof TailscaleNetworkSchema>

export default TailscaleNetworkSchema;
